import * as React from 'react';
import { SvgComponentProps, Svg } from './svg-component';

export const BoltCircleIcon = ({ size, ...rest }: SvgComponentProps) => (
    <Svg width={size || 24} height={size || 24} viewBox="0 0 24 24" fill="none" {...rest}>
        <path
            fill="currentColor"
            stroke="currentColor"
            strokeWidth="1.15"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M12.08 7.87v3.18h2.78l-2.94 5.08v-3.18H9.14l2.94-5.08z"
        />
        <circle stroke="currentColor" strokeWidth="1.5" cx="12" cy="12" r="11" />
        {/* <path
            fill="currentColor"
            d="M12,21.33c-5.15,0-9.33-4.18-9.33-9.33H0c0,6.63,5.37,12,12,12V21.33z M21.33,12c0,5.15-4.18,9.33-9.33,9.33V24
	c6.63,0,12-5.37,12-12H21.33z M12,2.67c5.15,0,9.33,4.18,9.33,9.33H24c0-6.63-5.37-12-12-12V2.67z M12,0C5.37,0,0,5.37,0,12h2.67
	c0-5.15,4.18-9.33,9.33-9.33V0z"
        /> */}
    </Svg>
);
